import Vue from 'vue'
import moment from 'moment-timezone'

const Scheduler = {
  encodeStartTime(startTime) {
    return encodeURIComponent(startTime)
  },

  async listDeviceEvents(deviceGuid, query = {}) {
    const response = await Vue.axios.get(
      '/devices/' + deviceGuid + '/scheduler/events',
      { params: query }
    )
    return response.data
  },

  async getEvent(deviceGuid, startTime) {
    const response = await Vue.axios.get(
      '/devices/' +
        deviceGuid +
        '/scheduler/events/' +
        this.encodeStartTime(startTime)
    )
    return response.data
  },

  async createEvent(deviceGuid, payload) {
    const response = await Vue.axios.post(
      '/devices/' + deviceGuid + '/scheduler/events',
      payload
    )
    return response.data
  },

  async updateEvent(deviceGuid, startTime, payload, scope = 'this') {
    const response = await Vue.axios.patch(
      '/devices/' +
        deviceGuid +
        '/scheduler/events/' +
        this.encodeStartTime(startTime),
      payload,
      { params: { scope } }
    )
    return response.data
  },

  async deleteEvent(deviceGuid, startTime, scope = 'this') {
    const response = await Vue.axios.delete(
      '/devices/' +
        deviceGuid +
        '/scheduler/events/' +
        this.encodeStartTime(startTime),
      { params: { scope } }
    )
    return response.data
  },

  deviceDisplayLabelFromDevice(device) {
    if (!device) {
      return ''
    }
    if (
      typeof device.hasMetadataKey === 'function' &&
      device.hasMetadataKey('device_alias')
    ) {
      return Vue.helpers.htmlDecode(device.metadataValue('device_alias'))
    }
    if (device.serial_number) {
      return device.serial_number
    }
    return device.device_guid || ''
  },

  _deviceDisplayLabel(deviceRow, metadata) {
    const aliasEntry = (metadata || []).find(
      (entry) => entry.key === 'device_alias' && entry.value
    )
    if (aliasEntry) {
      return Vue.helpers.htmlDecode(aliasEntry.value)
    }
    if (deviceRow && deviceRow.serial_number) {
      return deviceRow.serial_number
    }
    return (deviceRow && deviceRow.device_guid) || ''
  },

  async _resolveDeviceDisplayName(deviceRow) {
    let metadata = []
    try {
      const response = await Vue.axios.get(
        '/devices/' + deviceRow.device_guid + '/metadata'
      )
      metadata = response.data.metadata || []
    } catch (err) {
      console.warn(
        'Scheduler metadata load failed for',
        deviceRow.device_guid,
        err
      )
    }
    return this._deviceDisplayLabel(deviceRow, metadata)
  },

  async loadDeviceEvents(deviceGuid, deviceName) {
    const tz = Vue.helpers.getDisplayTimezone()
    const from = moment.tz(tz).subtract(30, 'days').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
    const to = moment.tz(tz).add(365, 'days').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
    const data = await this.listDeviceEvents(deviceGuid, { from, to })
    const name = deviceName || deviceGuid
    return (data.events || []).map((evt) => ({
      ...evt,
      device_guid: deviceGuid,
      device_name: name,
      scheduler_sync_pending: data.scheduler_sync_pending,
    }))
  },

  _fleetDeviceDisplayName(device) {
    return this.deviceDisplayLabelFromDevice(device)
  },

  async loadFleetEvents(fleet) {
    const allEvents = []
    const devices = fleet.devices || []
    for (const device of devices) {
      try {
        const data = await this.loadDeviceEvents(
          device.device_guid,
          this._fleetDeviceDisplayName(device)
        )
        allEvents.push(...data)
      } catch (err) {
        console.warn('Scheduler events load failed for', device.device_guid, err)
      }
    }
    return allEvents
  },

  eventKey(evt) {
    return evt.device_guid + '|' + evt.start_time
  },
}

export default Scheduler
